import { useEffect, useState, lazy, Suspense } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
  matchPath,
} from "react-router-dom";
import Home from "./screens/Home";
import Items from "./screens/ItemsPage/Items";
// /c/:slug — lazy nahi: hard-load par Suspense ke andar atak jaata tha (20-60 s tak kuch render nahi), Items waise bhi main bundle me hai.
import CategoryBySlug from "./screens/ItemsPage/CategoryBySlug";
import SingleProduct from "./screens/SingleProduct/SingleProduct";
import AboutUs from "./screens/AboutUs/Aboutus";
import WhatsappIcon from "./screens/extra/WhatsappIcon";
import ContactUs from "./screens/ContactUs/ContactUs";
import { Navigation } from "./screens/Components/Navigation";
import CategoryPage from "./screens/CategoryPage/category";
import { Loading } from "./common/Loader";
import CompanyPage from "./screens/CompanyPage/Company";
import { Tracking } from "./screens/tracking/Tracking";
import { TrackYourOrder } from "./screens/tracking/TrackYourOrder";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./Redux/store";
import { useGetProfileQuery } from "./Redux/Api/Contractor";
import { ContractorData, LoginResponse } from "./Redux/reducer/LoginReducer";
import PrivateRoute from "./screens/Components/protectedRoute";
import PublicRoute from "./screens/Components/PublicRoute";
import useScrollToTop from "./common/hooks/useScrollToTop";
import Unauthorized from "./screens/Components/unauthorizedRoute";
import { HoldOnPage } from "./screens/Unauthorized/HoldOnPage/HoldOnPage";
import SubItem from "./screens/subitem/subItem";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { clearResults, clearSearchOnPages } from "./Redux/reducer/Filter";
import AnimatedDiv from "./screens/Login/Auth";
import { SearchPage } from "./common/SearchPage";
import Header from "./screens/Components/Header";
import Navbar from "./screens/Components/Navbar";
import { Profile } from "./screens/Profile/Profile";
import Footer from "./common/Footer";
import { CustomerEntry } from "./screens/Profile/Components/CustomerEntry";
import { Query } from "./screens/Profile/Components/Query";
import ContractorCoinHistory from "./screens/Profile/Components/CoinHistory";
import "./config/i18nConfig";
import "./i18n";
import ErrorPage from "./screens/Error/Error";
import { Faq } from "./screens/Faqs/Faq";
import { Rewards } from "./screens/Profile/Components/Rewards";
// import { AssignedRewards } from "./common/AssignedRewards";
import DeleteAccount from "./screens/DeleteAccount/DeleteAccount";
import SealAnimation from "./screens/Components/turnover2";

import ReactGA from "react-ga4";
import QuotationTracker from "./screens/Profile/Components/QuotationTracker";
import DeleteAccountResponse from "./screens/Unauthorized/DeleteAccountResponse";
import DeletedCheck from "./screens/Components/DeletedCheck";
import AssignedRewards from "./screens/assignedRewards/AssignedRewards";
import AssignedCategoryItem from "./screens/assignedRewards/assignedCategoryItem/AssignedCategoryItem";
import PrivacyPolicy from "./common/PrivacyPolicy";
import OTPForm from "./screens/Login/OTPForm";
import RequestOTP from "./screens/Login/forgetPassword/RequestOTP";
import ForgotPassword from "./screens/Login/forgetPassword/ForgetPassword";
import VerifyOTP from "./screens/Login/forgetPassword/VerifyOTP";
import EditProfileDetails from "./screens/Profile/Components/EditProfileDetails";
import AddressBook from "./screens/Profile/Components/AddressBook";
import RateBand from "./screens/Components/RateBand";
import SiteSchema from "./common/seo/SiteSchema";
import ErrorBoundary from "./common/ErrorBoundaries";
import { hasStoredSession } from "./utils/session";

const RateToday = lazy(() => import("./screens/RateToday/RateToday"));
const MyOrders = lazy(() => import("./screens/Orders/MyOrders"));
const OrderDetail = lazy(() => import("./screens/Orders/OrderDetail"));
const Checkout = lazy(() => import("./screens/Checkout/Checkout"));
const OrderPlaced = lazy(() => import("./screens/Checkout/OrderPlaced"));

const Aside = lazy(() => import("./common/Aside/Aside"));
const Inventory = lazy(() => import("./screens/admins/Inventory/Inventory"));
const InventoryViewItem = lazy(() => import("./screens/admins/Inventory/InventoryViewItem"));
const InventoryCompanyProduct = lazy(() =>
  import("./screens/admins/Inventory/InventoryCompanyProduct").then((m) => ({ default: m.InventoryCompanyProduct }))
);
const Contractors = lazy(() =>
  import("./screens/admins/contractors/Contractors").then((m) => ({ default: m.Contractors }))
);
const ContractorsRequest = lazy(() =>
  import("./screens/admins/contractors/ContractorsRequest").then((m) => ({ default: m.ContractorsRequest }))
);
const Customer = lazy(() =>
  import("./screens/admins/contractors/Customer").then((m) => ({ default: m.Customer }))
);
const RequestReward = lazy(() =>
  import("./screens/admins/contractors/RequestReward").then((m) => ({ default: m.RequestReward }))
);
const RewardSytem = lazy(() =>
  import("./screens/admins/contractors/RewardSytem").then((m) => ({ default: m.RewardSytem }))
);
const Reward = lazy(() =>
  import("./screens/admins/contractors/Rewards").then((m) => ({ default: m.Reward }))
);
const InventaoryItemPage = lazy(() => import("./screens/admins/Inventory/inventaoryItemPage"));
const Orders = lazy(() => import("./screens/admins/Orders/order"));
const CompleteOrders = lazy(() => import("./screens/admins/Orders/completeOrders"));
const OrderRequest = lazy(() => import("./screens/admins/Orders/orderRequest"));
const InventoryCompany = lazy(() => import("./screens/admins/Inventory/InventoryCompany"));
const AdminLayout = lazy(() =>
  import("./screens/admins/Inventory/components/AdminComponents/adminLayout").then((m) => ({ default: m.AdminLayout }))
);
const Admin = lazy(() => import("./screens/admins/admin").then((m) => ({ default: m.Admin })));
const CompleteReferralOrderDetails = lazy(() => import("./screens/admins/Orders/completeReferralOrderDetails"));
const ReferralOrderDetails = lazy(() => import("./screens/admins/Orders/requestReferralOrderDetails"));
const AllContractorMessage = lazy(() => import("./screens/admins/contractors/allContratorMessagePage"));
const ContractorHistory = lazy(() => import("./screens/admins/contractors/contractorHistory"));
const Analytics = lazy(() =>
  import("./screens/admins/analytics/Analytics").then((m) => ({ default: m.Analytics }))
);
const CategoryDetails = lazy(() =>
  import("./screens/admins/Inventory/CategoryDetails").then((m) => ({ default: m.CategoryDetails }))
);
const ClaimedReward = lazy(() =>
  import("./screens/admins/contractors/ClaimedRewrads").then((m) => ({ default: m.ClaimedReward }))
);
const Cart = lazy(() => import("./screens/Cart/Cart"));
// MyProfile qrcode.react + html-to-image kheenchta hai aur milta sirf /profile
// par hai — pehle ye dono har pehle visit ke main bundle me jaate the.
const MyProfile = lazy(() =>
  import("./screens/Profile/Components/MyProfile").then((m) => ({ default: m.MyProfile }))
);

// GA ek hi baar initialise ho — render body me rakhne se har render par
// dobara chalta tha.
ReactGA.initialize("G-Y3RHXRVJ4X");

function App() {
  const dispatch = useDispatch();
  const [userState, setUserState] = useState<null | ContractorData>();
  const [hasRedirected, setHasRedirected] = useState(false);
  // Anonymous visitor ke liye profile call ka koi matlab nahi — wo sirf 401
  // deti hai aur home page ke critical path par baithi rehti hai.
  const { data: userResponse } = useGetProfileQuery(undefined as any, {
    skip: !hasStoredSession(),
  });
  const navigate = useNavigate();
  const location = useLocation();

  // --------------------------------React JoyRide Start---------------------------------
  // const [isTourOpen, setIsTourOpen] = useState<boolean>(false);

  // const steps: ReactourStep[] = [
  //   {
  //     selector: "#mobileSideBar",
  //     content: "This is the global navigation bar. Use it to explore the app.",
  //   },
  //   {
  //     selector: "#companies",
  //     content: "Here you can find various companies listed. Click to learn more about each one.",
  //   },
  //   {
  //     selector: "#categories",
  //     content: "These are the categories available on the Home Page. Click on one to view related items.",
  //   },

  //   {
  //     selector: "#footer",
  //     content: "This is the footer. You can find additional links and information here.",
  //   },
  // ];

  // useEffect(() => {
  //   // Check if the screen width is below 768px (mobile devices)
  //   const isMobile = window.innerWidth <= 768;

  //   if (isMobile) {
  //     // Simulate loading for 1.5 seconds, then open the tour
  //     const timer = setTimeout(() => {
  //       setIsTourOpen(false); // Start the tour for mobile devices
  //     }, 1500);

  //     return () => clearTimeout(timer);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (isTourOpen) {
  //     document.body.style.overflow = "hidden"; // Disable scrolling
  //   } else {
  //     document.body.style.overflow = ""; // Re-enable scrolling
  //   }

  //   return () => {
  //     document.body.style.overflow = ""; // Cleanup on unmount
  //   };
  // }, [isTourOpen]);

  // --------------------------------React JoyRide End---------------------------------





  useEffect(() => {
    if (userResponse) {
      setUserState(userResponse);
      dispatch(LoginResponse(userResponse));
    }
  }, [userResponse, dispatch]);

  const userDetails = useSelector(
    (state: RootState) => state.Login.ContractorData
  );

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location.pathname]);

  const role = userDetails?.role;
  const isFromSearch = useSelector(
    (state: RootState) => state.selection.isFromSearch
  );

  useEffect(() => {
    if (isFromSearch) {
      dispatch(clearSearchOnPages(location.pathname));
    }
  }, [location.pathname, isFromSearch, dispatch]);

  useEffect(() => {
    if (role === "admin" && !hasRedirected) {
      navigate("/admin");
      setHasRedirected(true);
    }
  }, [role, navigate, hasRedirected]);

  // useEffect(() => {
  //   const handleRouteChange = (url: string) => {
  //     if (window.gtag) {
  //       window.gtag("config", "G-Y3RHX   npm install react-gaRVJ4X", {
  //         page_path: url,
  //       });
  //     }
  //   };
  // })


  useScrollToTop();

  const hideHeaderAndNavbar =
    location.pathname.startsWith("/admin") ||
    location.pathname === "/searchpage" ||
    location.pathname === "";



  const routes = [
    "/", "/admin", "/signup", "/unauthorized", "deleted", "/response", "/assignrewards", "/items/:id?/:type?/:name?", "/profile/entry",
    "/product/:id/:name", "/aboutus", "/contactus", "/categories", "/company", "/profile/Query", "/profile/rewards",
    "/order", "/tracking/:name", "/subItems", "/searchpage", "/profile", "/profile/history", "/profile/quotation-tracker", "/faq", "/delete-account", "/category-item", "/privacy-policy", "/profile/addresses", "/cart", "/rate-today", "/profile/my-orders", "/profile/my-orders/:orderNumber", "/checkout", "/order-placed/:orderNumber", "/c/:slug",
  ];

  const isNotRoute = routes.some(route => matchPath(route, location.pathname))
  // , "/forgot-password/request-otp", "/forgot-password", "/forgot-password/verify-otp"

  // Google Tag Manager

  // useEffect(() => {
  //   const tagManagerArgs = {
  //     gtmId: 'GTM-Y3RHXRVJ4X',
  //   }
  //   TagManager.initialize(tagManagerArgs)
  // }, [])



  useEffect(() => {
    const defaultKeywords = "Chawla Ispat, steel products, bars, steel solutions, high-quality steel, competitive prices";
    const homeKeywords = "Chawla Ispat, Building material supplier, Construction material suppliers";

    let keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (!keywordsMetaTag) {
      keywordsMetaTag = document.createElement('meta');
      keywordsMetaTag.setAttribute('name', 'keywords');
      document.head.appendChild(keywordsMetaTag);
    }
    if (location.pathname === '/') {
      keywordsMetaTag.setAttribute("content", homeKeywords);
    } else {
      keywordsMetaTag.setAttribute("content", defaultKeywords);
    }
  }, [location]);

  useEffect(() => {
    // NOTE: App root ke effects child (Items) ke effects ke BAAD chalte hain.
    // /c/:slug par Items.tsx khud setSelectedCategories([cat]) karta hai, aur ye
    // clearResults() usko turant wapas [] kar deta tha -> har category page poora
    // catalogue (2000+ items) dikhata tha. Isliye /c/ ko bhi chhodna zaroori hai.
    if (!location.pathname.startsWith("/items") && !location.pathname.startsWith("/c/")) {
      dispatch(clearResults())
    }

  }, [location.pathname]);



  const excludeNavigationRoutes = [
    "/searchpage",
    "/product/:name",
    "/profile/edit",
    "/otp-verification",
    "forgot-password/request-otp",
    "forgot-password",
    "forgot-password/verify-otp",
    "otp-verification",
  ];

  const isExcluded = excludeNavigationRoutes.some((route) =>
    matchPath(route, location.pathname)
  );


  return (
    <div className="bg-white flex flex-col min-h-screen">
      <SiteSchema />
      {/* <Tour
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={() => setIsTourOpen(false)}
      /> */}


      <div>
        {
          !isExcluded && <WhatsappIcon />
        }

      </div>
      {(
        <>
          <div className="flex flex-col font-inter flex-grow">
            {!hideHeaderAndNavbar && isNotRoute && <Header />}
            {!hideHeaderAndNavbar && isNotRoute && <Navbar />}
            {!hideHeaderAndNavbar && isNotRoute && <RateBand />}
            {/* <BackButton /> */}
            <div className="flex-grow">
              <Suspense fallback={<Loading />}>
              {/* Ek bhi screen ke render me exception aaya to pehle poora page
                  safed ho jaata tha (cart/checkout par ye asli khatra tha).
                  key={pathname} — navigate karte hi boundary reset ho jaaye. */}
              <ErrorBoundary key={location.pathname}>
              <Routes>
                <Route element={<PrivateRoute roles={["admin"]} />}>
                  <Route
                    path="/admin"
                    element={
                      <Aside>
                        <Admin />
                      </Aside>
                    }
                  />
                  <Route
                    path="/admin/category"
                    element={
                      <AdminLayout>
                        <Inventory />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/category/view/:id"
                    element={
                      <AdminLayout>
                        <InventoryViewItem />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/category/item/:id"
                    element={
                      <AdminLayout>
                        <InventaoryItemPage />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/categoryDetails/:id"
                    element={
                      <AdminLayout>
                        <CategoryDetails />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/company"
                    element={
                      <AdminLayout>
                        <InventoryCompany />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/company/:name"
                    element={
                      <AdminLayout>
                        <InventoryCompanyProduct />
                      </AdminLayout>
                    }
                  />
                  {/* <Route
                    path="/admin/customers"
                    element={
                      <AdminLayout>
                        <Customers />
                      </AdminLayout>
                    }
                  /> */}
                  <Route
                    path="/admin/contractors"
                    element={
                      <AdminLayout>
                        <Contractors />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/contractors/request"
                    element={
                      <AdminLayout>
                        <ContractorsRequest />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/contractors/profile/:id"
                    element={
                      <AdminLayout>
                        <Customer />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/contractors/delete"
                    element={
                      <AdminLayout>
                        <ContractorHistory />
                      </AdminLayout>
                    }
                  />

                  <Route
                    path="/admin/reward/request"
                    element={
                      <AdminLayout>
                        <RequestReward />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/reward/claim"
                    element={
                      <AdminLayout>
                        <ClaimedReward />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/reward/rewardSystem"
                    element={
                      <AdminLayout>
                        <RewardSytem />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/reward"
                    element={
                      <AdminLayout>
                        <Reward />
                      </AdminLayout>
                    }
                  />
                  <Route
                    path="/admin/analytics"
                    element={
                      <AdminLayout>
                        <Analytics />
                      </AdminLayout>
                    }
                  />

                  <Route
                    path="/admin/orders"
                    element={
                      <Aside>
                        <Orders />
                      </Aside>
                    }
                  >
                    <Route index element={<Navigate to="request" />} />
                    <Route path="request" element={<OrderRequest />} />
                    <Route
                      path="request/:id"
                      element={<ReferralOrderDetails />}
                    />
                    <Route path="complete" element={<CompleteOrders />} />
                    <Route
                      path="complete/:id"
                      element={<CompleteReferralOrderDetails />}
                    />
                  </Route>

                  <Route
                    path="/admin/message"
                    element={
                      <Aside>
                        <AllContractorMessage />
                      </Aside>
                    }
                  />
                </Route>

                <Route element={<PrivateRoute roles={["admin", "contractor"]} />}
                >
                  <Route
                    path="/profile"
                    element={
                      <Profile>
                        <MyProfile />
                      </Profile>
                    }
                  />
                  <Route
                    path="/profile/edit"
                    element={
                      <Profile>
                        <EditProfileDetails />
                      </Profile>
                    }
                  />
                  <Route
                    path="/profile/history"
                    element={
                      <Profile>
                        <ContractorCoinHistory />{" "}
                      </Profile>
                    }
                  />
                  <Route
                    path="/profile/rewards"
                    element={
                      <Profile>
                        <Rewards />
                      </Profile>
                    }
                  />
                  <Route
                    path="/profile/entry"
                    element={
                      <Profile>
                        <CustomerEntry />
                      </Profile>
                    }
                  />
                  <Route
                    path="/profile/Query"
                    element={
                      <Profile>
                        <Query />
                      </Profile>
                    }
                  />
                  <Route
                    path="/profile/quotation-tracker"
                    element={
                      <Profile>
                        <QuotationTracker />
                      </Profile>
                    }
                  />
                  <Route
                    path="/profile/addresses"
                    element={
                      <Profile>
                        <AddressBook />
                      </Profile>
                    }
                  />
                  <Route
                    path="/profile/my-orders"
                    element={
                      <Profile>
                        <MyOrders />
                      </Profile>
                    }
                  />
                  <Route
                    path="/profile/my-orders/:orderNumber"
                    element={
                      <Profile>
                        <OrderDetail />
                      </Profile>
                    }
                  />
                </Route>
                
                <Route element={<DeletedCheck />}>
                  <Route path="/deleted" element={<DeleteAccountResponse />} />
                </Route>

                <Route element={<Unauthorized />}>
                  <Route path="/unauthorized" element={<HoldOnPage />} />
                </Route>

                {/* <Route element={<SignupCheck />}>
                  <Route path="/response" element={<SignupResponse />} />
                </Route> */}

                <Route element={<PublicRoute />}>
                  <Route path="/signup" element={<AnimatedDiv />} />
                  <Route path="/otp-verification" element={<OTPForm />} />
                  {/* Forget Password */}
                  <Route path="/forgot-password/request-otp" element={<RequestOTP />} />
                  <Route path="/forgot-password/verify-otp" element={<VerifyOTP />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                </Route>

                <Route path="/" element={<Home />} />
                <Route path="/assignrewards" element={<AssignedRewards />} />
                <Route path="/category-item" element={<AssignedCategoryItem />} />
                <Route path="/items/:id?/:type?/:name?" element={<Items />} />
                <Route path="/c/:slug" element={<CategoryBySlug />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order-placed/:orderNumber" element={<OrderPlaced />} />
                {/* <Route path="/items" element={<Items />} /> */}
                <Route path="/product/:id/:name" element={<SingleProduct />} />
                <Route path="/aboutus" element={<AboutUs />} />
                <Route path="/contactus" element={<ContactUs />} />
                <Route path="/categories" element={<CategoryPage />} />
                <Route path="/company" element={<CompanyPage />} />
                <Route path="/order" element={<Tracking />} />
                <Route path="/tracking/:name" element={<TrackYourOrder />} />
                <Route path="/subItems" element={<SubItem />} />
                <Route path="/searchpage" element={<SearchPage />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/delete-account" element={<DeleteAccount />} />
                <Route path="/open" element={<CategoryDetails />} />
                <Route path="/turnOver" element={<SealAnimation />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/rate-today" element={<RateToday />} />
                <Route path="*" element={<ErrorPage />} />
              </Routes>
              </ErrorBoundary>
              </Suspense>
            </div>
            {!location.pathname.startsWith("/admin") && isNotRoute && (
              <Footer />
            )}
          </div>
          {!isExcluded && <Navigation />}
        </>
      )}
      <ToastContainer
        position="top-center"
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
